import React, { FunctionComponent } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";

import { isLoadingSelector } from "../../../../store/ducks/requirementList/selectors";

import { TitleSection } from "./style";
import NewPurchaseRequirementButton from "../NewPurchaseRequirementButton";
import { fetchRequirements } from "../../../../usecases/requirement/requirementListUseCase";
import RoundedGreenButton from "../../../../components/RoundedGreenButton";
import { Button } from "@mui/material";
import { FiFilter } from "react-icons/fi";
import { useGetRequirementsFilterCountQuery } from "../../../../services/api";

type PhaseFiltersProps = {
  data: Array<{label:string, keyword: string}>
  fetchByStatus: (filter: string) => void;
}

export const PhaseFilters: FunctionComponent<PhaseFiltersProps> = ({data, fetchByStatus}) => {
  const FILTERS = [
    {
      label: "Planning & Scheduling",
      keyword: "planningAndScheduling",
    },
    {
      label: "Process Engineering",
      keyword: "processEngineering",
    },
    {
      label: "Feedstock Trading",
      keyword: "feedstockTrading",
    },
    {
      label: "Concluded",
      keyword: "concluded",
    },
  ];

  const renderCount = (key: string) => {
    return data?.[key] || "";
  };

  return (
    <>
      <Grid item>
        <Typography>Phase:</Typography>
      </Grid>
      {[FILTERS.map((filter) => (
        <Grid item key={filter.keyword}>
          <RoundedGreenButton
            color="success"
            size="large"
            onClick={() => fetchByStatus(filter.keyword)}
            variant="contained"
          >
            {`${filter.label} ${renderCount(filter.keyword)}`}
          </RoundedGreenButton>
        </Grid>
      ))]}
    </>
  );
};

export function RequirementListHeader({onOpenFilter}: {onOpenFilter: () => void}) {
  const dispatch = useDispatch();
  const {data: countsData} = useGetRequirementsFilterCountQuery();

  const fetchByStatus = (filter: string) => {
    let params = undefined;
    if (filter === "planningAndScheduling") {
      params = "filter[status][0]=technical_approved&filter[status][1]=technical_rejected&filter[status][2]=technical_approved_with_restriction&filter[status][3]=planning_evaluation&filter[status][4]=missing_information";
    } else if (filter === "processEngineering") {
      params = "filter[status][0]=process_evaluation";
    } else if (filter === "feedstockTrading") {
      params = "filter[status][0]=request_extra_information&filter[status][1]=draft";
    } else if (filter === "concluded") {
      params = "filter[status][0]=approved&filter[status][1]=approved_with_restrictions&filter[status][2]=rejected";
    }
    
    fetchRequirements(`?${params}`, 0, 10)(dispatch);
  };

  const isListLoading = useSelector(isLoadingSelector);

  return (
    <TitleSection container sx={{ marginTop: "60px" }}>
      <Grid item sm={8}>
        <Typography variant="h2" sx={{ fontWeight: "bold" }}>
          Requirements List
        </Typography> 
      </Grid>
      <Grid item md={4} display="flex" justifyContent="end">
        <NewPurchaseRequirementButton />
      </Grid>
      <Grid md={12} item mb={4} style={{ marginTop: "20px" }}>
        {isListLoading ? null : (
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button
                color="secondary"
                onClick={onOpenFilter}
                startIcon={<FiFilter />}
                variant="outlined"
              >
                Filters
              </Button>
            </Grid>
            <Grid container item justifyContent="flex-end" columnSpacing={3} md={9} alignItems='center'>
              <PhaseFilters data={countsData} fetchByStatus={fetchByStatus} />
            </Grid>
          </Grid>
        )}
      </Grid>
    </TitleSection>
  );
}
